module.exports = __webpack_public_path__ + "img/icon_agregar_responsable.e5b56e30.svg";